import PageComponent from '../base/PageComponent';
export default class DateField extends PageComponent { 
    init() {

        this.element.on("keydown", function (event) {
            return event.key != "Enter";
        });
    }
}